const baseUrl = 'auth';

export const ApiAuth = {
  // gateway-service (BU-20639) - LinkPass authentication; also returns onboardingRequired/
  // bootstrapToken for the B3 onboarding wizard (see redux/app/actions.ts generateAssociation)
  GenerateAssociation: `${baseUrl}/validate`,
  // gateway-service (BU-21057) - tears down the single active LinkPass session record and the
  // cached B3 token; see config/auth.ts Auth0Service.logOut
  Logout: `${baseUrl}/logout`
};
